import { GuideItem, GuideContent } from '../guides';

export const guide4Item: GuideItem = {
  id: '4',
  title: 'Korean Souvenir Guide: What Visitors Really Take Home',
  titleEn: 'Korean Souvenir Guide: What Visitors Really Take Home',
  titleJa: '韓国おみやげガイド：外国人旅行者が本当に買って帰るもの',
  titleZhCn: '韩国伴手礼指南：外国游客最爱带走的好物',
  titleZhTw: '韓國伴手禮指南：外國旅客最愛帶回家的好物',
  image: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-EN.png',
  imageEn: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-EN.png',
  imageJa: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-JP.png',
  imageZhCn: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-CN.png',
  imageZhTw: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-TW.png',
  description: '',
  descriptionEn: '',
  descriptionJa: '',
  descriptionZhCn: '',
  descriptionZhTw: ''
};

export const guide4Content: GuideContent = {
  title: 'Korean Souvenir Guide: What Visitors Really Take Home',
  titleEn: 'Korean Souvenir Guide: What Visitors Really Take Home',
  titleJa: '韓国おみやげガイド：外国人旅行者が本当に買って帰るもの',
  titleZhCn: '韩国伴手礼指南：外国游客最爱带走的好物',
  titleZhTw: '韓國伴手禮指南：外國旅客最愛帶回家的好物',
  subtitle: '',
  subtitleEn: '',
  subtitleJa: '',
  subtitleZhCn: '',
  subtitleZhTw: '',
  markdownContent: `

  ![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-EN.png)  

What should you bring home from your Korea trip?

Looking for the perfect way to remember your time in Korea?
Whether you’re buying for friends, family, or yourself,
here are 5 souvenirs handpicked by locals and loved by international visitors — meaningful, fun, and full of Korean charm.

## 1. Mother-of-Pearl Compact Mirror

![대지 16.png](attachment:fcca59c1-2c1d-4daf-8c2a-988e29f72847:대지_16.png)

# (버튼 1)

A little piece of Korean elegance — mother-of-pearl art in your hand.

This shimmering craft, made from finely ground seashells, was once used by Korean royalty to decorate furniture and accessories.
Now, it's reborn as a stylish compact mirror — both practical and beautiful.

👉 Want to be a thoughtful husband, boyfriend, or son? This is a guaranteed “wow” gift.
(The kind that makes people say “Oh wow!” as soon as they open it.)

---

## 2. Korean Landmark Magnets

![대지 16-1.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-2.png)

# (버튼 2)

A must for travel lovers! Complete your fridge collection with Korea.

Magnets featuring Gyeongbokgung Palace, Namsan Tower, and traditional hanbok characters —
these cute and lightweight souvenirs capture Korea’s beauty in a fun, collectible form.

Did you know that fridge magnet collecting has become a global trend among travelers?

👉 Want to leave a trace of your trip on your fridge? Add this one to your cart!

---

## 3. Roasted Seaweed Snacks (Gim)

![16-2.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-3.png)

# (버튼 3)

Addictive, crunchy, and globally loved — the ultimate K-snack!

Korean “gim” is savory and crispy, the kind of snack you can’t stop munching.
It’s tasty on its own, but pair it with warm rice, and it’s amazing.

Korean seaweed snacks are now popular worldwide — easy to find in global supermarkets.

👉 A healthy, tasty, and iconic Korean food souvenir.

---

## 4. Korean-Style “New Mix” Coffee

![16-3.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E186%B7-4.png)

# (버튼 4)

K-coffee vibes: sweet, creamy, and totally gift-worthy.

Born from the classic instant coffee culture in Korea,
“New Mix” coffee takes it to the next level with stylish packaging and a smoother taste.

It’s become a hot souvenir item among tourists —
hip, sweet, and so easy to enjoy anywhere.

👉 If you love coffee, don’t leave Korea without it!

---

## 5. Red Ginseng Sticks

![16-4.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-5.png)

# (버튼 5)

A gift of wellness, wrapped in convenience.

Red ginseng — Korea’s traditional superfood — now comes in handy stick packs
you can take and enjoy anytime, anywhere.

Perfect for boosting energy, immunity, and vitality — without the bulk.

👉 Great for parents, older relatives, or health-conscious friends.
A gift that says “I care” in the most Korean way.

🎀 Final Tip
If “souvenir” sounds too ordinary, remember these five.
They’re not just gifts — they carry a piece of Korea and the memories of your trip.

Pack them in your suitcase and share a bit of Korea with the people you love.
  `,
  markdownContentEn: `


  ![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-EN.png)  

What should you bring home from your Korea trip?

Looking for the perfect way to remember your time in Korea?
Whether you’re buying for friends, family, or yourself,
here are 5 souvenirs handpicked by locals and loved by international visitors — meaningful, fun, and full of Korean charm.

## 1. Mother-of-Pearl Compact Mirror

![대지 16.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-1.png)

# (버튼 1)

A little piece of Korean elegance — mother-of-pearl art in your hand.

This shimmering craft, made from finely ground seashells, was once used by Korean royalty to decorate furniture and accessories.
Now, it's reborn as a stylish compact mirror — both practical and beautiful.

👉 Want to be a thoughtful husband, boyfriend, or son? This is a guaranteed “wow” gift.
(The kind that makes people say “Oh wow!” as soon as they open it.)

---

## 2. Korean Landmark Magnets

![대지 16-1.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-2.png)

# (버튼 2)

A must for travel lovers! Complete your fridge collection with Korea.

Magnets featuring Gyeongbokgung Palace, Namsan Tower, and traditional hanbok characters —
these cute and lightweight souvenirs capture Korea’s beauty in a fun, collectible form.

Did you know that fridge magnet collecting has become a global trend among travelers?

👉 Want to leave a trace of your trip on your fridge? Add this one to your cart!

---

## 3. Roasted Seaweed Snacks (Gim)

![16-2.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-3.png)

# (버튼 3)

Addictive, crunchy, and globally loved — the ultimate K-snack!

Korean “gim” is savory and crispy, the kind of snack you can’t stop munching.
It’s tasty on its own, but pair it with warm rice, and it’s amazing.

Korean seaweed snacks are now popular worldwide — easy to find in global supermarkets.

👉 A healthy, tasty, and iconic Korean food souvenir.

---

## 4. Korean-Style “New Mix” Coffee

![16-3.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-4.png)

# (버튼 4)

K-coffee vibes: sweet, creamy, and totally gift-worthy.

Born from the classic instant coffee culture in Korea,
“New Mix” coffee takes it to the next level with stylish packaging and a smoother taste.

It’s become a hot souvenir item among tourists —
hip, sweet, and so easy to enjoy anywhere.

👉 If you love coffee, don’t leave Korea without it!

---

## 5. Red Ginseng Sticks

![16-4.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-5.png)

# (버튼 5)

A gift of wellness, wrapped in convenience.

Red ginseng — Korea’s traditional superfood — now comes in handy stick packs
you can take and enjoy anytime, anywhere.

Perfect for boosting energy, immunity, and vitality — without the bulk.

👉 Great for parents, older relatives, or health-conscious friends.
A gift that says “I care” in the most Korean way.

&nbsp;

🎀 Final Tip
If “souvenir” sounds too ordinary, remember these five.
They’re not just gifts — they carry a piece of Korea and the memories of your trip.

Pack them in your suitcase and share a bit of Korea with the people you love.

  `,
  markdownContentJa: `

  ![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-JP.png)  

韓国旅行の最後に、何を記念に持ち帰ろう？

旅行の思い出を形にしたいあなたへ。
家族や友達、自分用にもぴったりの—
韓国人が選び、実際に外国人旅行者に人気の「本当に喜ばれる」お土産5選をご紹介します。

## 1. 螺鈿（らでん）のコンパクトミラー小さな芸術作品のような韓国の伝統美。

![대지 16.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-1.png)

# (버튼 1)

螺鈿（らでん）とは、貝殻を薄く削って模様にする伝統工芸。
朝鮮時代には王族の家具やアクセサリーに使われていました。

この技法で作られた手鏡は、実用的で美しく、女性へのお土産に大人気！

👉 センスのいい旦那さん、彼氏、息子になりたいならこれ一択。
開けた瞬間「わぁ〜♡」って声が出るギフトです。

---

## 2. 韓国名所マグネット旅行好きに大人気！冷蔵庫コレクションにぴったり。

![대지 16-1.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-2.png)

# (버튼 2)

景福宮や南山タワー、韓服キャラクターなど、
可愛いデザインで韓国の魅力がギュッと詰まったマグネットです。

最近では「旅行先のマグネットを集める」トレンドが世界中で流行中！

👉 旅の足跡を冷蔵庫に残したいなら、絶対コレ。

---

## 3. 味付け海苔（キム）おかずにもおやつにも！止まらないおいしさ。

![16-2.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-3.png)

# (버튼 3)

パリッとした食感と香ばしさがクセになる韓国の海苔スナック。
そのままでも、温かいご飯と一緒に食べても最高！

すでに世界中のスーパーでも売られていて大人気です。

👉 健康的で美味しい、完璧なKフードのお土産！

---

## 4. 韓国式「ニューミックスコーヒー」おしゃれで美味しい、韓国流インスタントコーヒー。

![16-3.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-4.png)

# (버튼 4)

昔ながらのミックスコーヒーが、今はスタイリッシュに進化！
可愛いパッケージとまろやかな味わいが特徴です。

外国人観光客の間でも「韓国で買うべきお土産」として人気急上昇中。

👉 コーヒー好きなら絶対にゲットして帰ろう！

---

## 5. 高麗人参スティック体調管理にぴったりのプレミアムギフト。

![16-4.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-5.png)

# (버튼 5)

韓国の伝統健康食「紅参（ホンサム）」が、
今ではスティックタイプになって手軽に飲めるようになりました。

いつでもどこでも健康チャージ！

👉 両親や年配の方、健康志向の友人へのお土産に最適です。

&nbsp;

🎀 最後のヒント

「お土産」という言葉にピンと来ない人も、

この5つはただの物ではなく、**韓国の文化と旅の思い出**が詰まっています。

スーツケースに、ぜひひとつ加えてください。
`,
  markdownContentZhCn: `

![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-CN.png)  
  
旅行快结束时，不知道该带什么回家？

想把韩国旅行的回忆带回去？

无论是送给家人、朋友，还是作为自己的纪念品，

以下是**由韩国人精心挑选、深受外国游客喜爱的5款纪念品**，实用又有意义！

## 1. 螺钿小镜子 传统工艺与优雅的结合。

![대지 16.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-1.png)

# (버튼 1)

螺钿是一种用贝壳雕刻镶嵌的装饰技艺，
过去曾用于宫廷家具和饰品，如今变身成实用又精致的小镜子。

👉 想成为贴心老公、男友或儿子？选它准没错！
打开那一刻，绝对让人眼前一亮！

---

## 2. 韩国地标冰箱贴 热爱旅行的你不能错过！全球旅行者的新宠。

![대지 16-1.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-2.png)

# (버튼 2)

景福宫、南山塔、韩服人物…

这些可爱的冰箱贴轻便又价格亲民，是送人的不二选择。

你知道吗？**收集各地冰箱贴已经成为全球旅行趋势**！

👉 想把旅行的足迹留在冰箱上？别错过这款！

---

## 3. 海苔（调味海苔小吃）当零食也超赞，配饭更绝！根本停不下来！

![16-2.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-3.png)

# (버튼 3)

酥脆香浓的韩式调味海苔，一试就爱上。
直接吃也好吃，配上热腾腾的米饭更是让人惊艳！

如今在国外超市也能轻松买到，全球人气超高！

👉 美味又健康，最值得带回的K-美食伴手礼！

---

## 4. 韩国「New Mix」咖啡 韩国风味+时尚设计的完美结合。

![16-3.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-4.png)

# (버튼 4)

韩国传统三合一咖啡，现在升级为“New Mix Coffee”
拥有更柔滑的口感和更潮的包装。

这款咖啡在外国游客中已经火到出圈，
甜而不腻，设计感十足，是旅行必备！

👉 咖啡控不可错过的韩国旅行纪念品！

---

## 5. 红参棒 方便又滋补，送礼自用都合适。

![16-4.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-5.png)

# (버튼 5)

韩国传统滋补品「红参」，
现在做成了便携式红参棒，随时随地轻松补充能量！

增强免疫力、缓解疲劳、恢复活力样样行！

👉 送给爸妈、长辈或健康达人，再合适不过！

&nbsp;

🎀小贴士

如果你觉得“纪念品”太普通，那就记住这五样吧。

它们不仅是物品，更是承载

**韩国文化与旅途回忆的特别礼物**！
  `,
  markdownContentZhTw: `

![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-TW.png)  

韓國之旅的最後，你想帶什麼回家作為紀念？

想把這趟旅程的美好回憶帶回去？

不管是送給親友，還是作為自用紀念，

以下是**由韓國人推薦、真正受到外國旅客喜愛的5大韓國伴手禮**！

## 1. 螺鈿手鏡 小巧精緻的韓式傳統工藝。

![대지 16.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-1.png)

# (버튼 1)

螺鈿是將貝殼磨薄鑲嵌而成的傳統裝飾技法，
在朝鮮時代被廣泛用於宮廷女性的飾品和傢俱上。

如今以手鏡形式呈現，美觀又實用。

👉 想成為貼心的老公、男友或兒子？這份禮物會大大加分！
一打開就能聽到「哇～」的驚嘆聲！

---

## 2. 韓國地標磁鐵 旅行控必收！全球冰箱貼的新寵兒。

![대지 16-1.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-2.png)

# (버튼 2)

包含景福宮、南山塔、穿韓服的小角色等圖案，

可愛又實用，是送人或收藏的最佳選擇。

現在全球旅人都在瘋**冰箱磁鐵蒐集**，你跟上了嗎？

👉 想在冰箱上留下一趟旅程的痕跡？別錯過它！

---

## 3. 海苔（調味海苔零食）可以當點心，也能配飯吃到停不下來！

![16-2.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-3.png)

# (버튼 3)

酥脆香濃的韓式海苔令人愛不釋口。
直接吃或配熱飯都讓人驚艷，是國際人氣K-snack！

現在在許多國家超市也能輕鬆買到，名副其實的國民美食。

👉 健康、美味又代表性十足，最佳的韓國食品紀念品！

---

## 4. 韓國風「New Mix Coffee」既時尚又美味，咖啡迷的最愛！

![16-3.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-4.png)

# (버튼 4)

韓國的三合一咖啡文化，
已升級為包裝潮流、口感升級的「New Mix Coffee」。

在外國旅客中超級受歡迎，甜而不膩，設計感爆棚！

👉 如果你喜歡咖啡，來韓國絕對要帶幾包回家！

---

## 5. 紅蔘棒 健康與方便兼具的高質感禮物。

![16-4.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%80%E1%85%B5%E1%84%82%E1%85%A7%E1%86%B7%E1%84%91%E1%85%AE%E1%86%B7-5.png)

# (버튼 5)

韓國傳統滋補食材「紅蔘」現在做成了方便攜帶的棒狀包裝，
提升免疫、恢復元氣，隨時隨地都能輕鬆補充。

👉 送爸媽、長輩或重視健康的朋友，絕對有誠意！

&nbsp;

🎀最後小建議

如果你覺得「伴手禮」太普通，

那這五樣東西會讓你留下**韓國文化與旅途的感動**。

打包放進行李箱，為你的旅行畫上完美句點吧！

  `,
  inlineButtons: [
    {
      id: "1",
      text: "Fast delivery – order now!",
      textEn: "Fast delivery – order now!",
      textJa: "迅速配送 – 今すぐご注文を！",
      textZhCn: "快速送达 – 立即下单！",
      textZhTw: "快速送達 – 立即下單！",
      url: "https://delivereee.github.io/home/#/shop/gift-shop-1/product/eYcNWqg2",
    },
    {
      id: "2",
      text: "Fast delivery – order now!",
      textEn: "Fast delivery – order now!",
      textJa: "迅速配送 – 今すぐご注文を！",
      textZhCn: "快速送达 – 立即下单！",
      textZhTw: "快速送達 – 立即下單！",
      url: "https://delivereee.github.io/home/#/shop/gift-shop-1/product/cSR2cgAu",
    },
    {
      id: "3",
      text: "Fast delivery – order now!",
      textEn: "Fast delivery – order now!",
      textJa: "迅速配送 – 今すぐご注文を！",
      textZhCn: "快速送达 – 立即下单！",
      textZhTw: "快速送達 – 立即下單！",
      url: "https://delivereee.github.io/home/#/shop/gift-shop-1/product/pnkODAiW"
    },
    {
      id: "4",
      text: "Fast delivery – order now!",
      textEn: "Fast delivery – order now!",
      textJa: "迅速配送 – 今すぐご注文を！",
      textZhCn: "快速送达 – 立即下单！",
      textZhTw: "快速送達 – 立即下單！",
      url: "https://delivereee.github.io/home/#/shop/gift-shop-1/product/cxCdHCgz",      
    },
    {
      id: "5",
      text: "Fast delivery – order now!",
      textEn: "Fast delivery – order now!",
      textJa: "迅速配送 – 今すぐご注文を！",
      textZhCn: "快速送达 – 立即下单！",
      textZhTw: "快速送達 – 立即下單！",
      url: "https://delivereee.github.io/home/#/shop/gift-shop-1/product/0hHwkkg9",
    },
  ]
}; 